import React, { createContext, useState, useEffect, useContext } from "react";
import axios from "../utils/axiosConfig.js";
import { toast } from "react-toastify";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Check if user is logged in on mount
  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      const response = await axios.get("/api/auth/me");
      setUser(response.data.user);
    } catch (error) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  const login = async (email, password) => {
    try {
      const response = await axios.post("/api/auth/login", { email, password });
      setUser(response.data.user);
      toast.success(`Willkommen zurück, ${response.data.user.firstName}!`);
      return { success: true };
    } catch (error) {
      const message = error.response?.data?.error || "Login fehlgeschlagen";
      toast.error(message);
      return { success: false, error: message };
    }
  };

  const logout = async () => {
    try {
      await axios.post("/api/auth/logout");
      setUser(null);
      // Clear all form-related localStorage items
      localStorage.removeItem('selectedStudentId');
      localStorage.removeItem('studentFormPage');
      localStorage.removeItem('selectedCoachId');
      toast.success("Erfolgreich abgemeldet");
    } catch (error) {
      console.error("Logout error:", error);
      // Clear user anyway
      setUser(null);
      // Clear localStorage even on error
      localStorage.removeItem('selectedStudentId');
      localStorage.removeItem('studentFormPage');
      localStorage.removeItem('selectedCoachId');
    }
  };

  const value = {
    user,
    loading,
    login,
    logout,
    isAuthenticated: !!user,
    isAdmin: user?.role === "admin",
    isTrainer: user?.role === "trainer",
    isViewer: user?.role === "viewer",
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within AuthProvider");
  }
  return context;
};

export default AuthContext;
